import React, {PureComponent} from "react";
import Table from "react-bootstrap/Table";
import {PropTypes} from "prop-types";
import {debug, find} from "../../../utility/functions";
import './index.css';
import {appendStrings} from "./functions";

class GenericTable extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			selectedRows: null,
		}
	}

	capitalize = (s) => {
		if (typeof s !== 'string') return '';
		return s.charAt(0).toUpperCase() + s.slice(1)
	};

	callbackWithSelectedRows = () => {
		const {onSelected} = this.props;
		if(!onSelected) return null;
		onSelected(this.state.selectedRows);
	};

	onRowSelected = (row, index) => {
		const {selectType, onSelected} = this.props;

		if(!selectType || selectType === 'none') return;

		if(selectType === 'single') {
			this.setState({
				selectedRows: [{row, index}]
			}, () => {
				this.callbackWithSelectedRows()
			})
		}
		if(selectType === 'multi') {
			this.setState({
				selectedRows: this.state.selectedRows? [...this.state.selectedRows, {row, index}] : [{row, index}]
			}, () => {
				this.callbackWithSelectedRows()
			})
		}

		if(!onSelected) return null;

		onSelected([
			{row, index}
		]);
	};

	renderRowsFieldsTypes(value, index) {
		const {types} = this.props;
		if (!types || types.length === 0 || !types[index] || !value) return null;
		switch (types[index]) {
			case 'string':
				return String(value);
			case 'int':
				return Int32Array(value);
			case 'float':
				return Float32Array(value);
			case 'bool':
				return String(Boolean(value));
			case 'object':
				return Object(value);
			case 'array':
				return Array(value);
			default:
				return value;
		}
	}

	renderRowsFields(row) {
		const {fields} = this.props;
		if (!fields || fields.length === 0) return null;

		return fields.map((field, index) => {
			const f = find(field, 'field');
			let value = this.renderRowsFieldsTypes(find(row, f), index);

			const renderCustomComponent = find(field, 'component');
			if(renderCustomComponent){
				return (
					<td
						key={field + index}
						className={appendStrings("generic-table-column-container", this.props.dataContainerClassName)}
					>
						{renderCustomComponent(row, find(row, f), value)}
					</td>
				)
			}

			return (
				<td
					key={field + index}
					className={appendStrings("generic-table-column-container", this.props.dataContainerClassName)}
				>
					{value || "- - -"}
				</td>
			)
		})
	}

	renderActions(r, index) {
		const {renderActions} = this.props;
		if (!renderActions) return null;
		return (
			<td key={"actions"}>
				{renderActions(r, index)}
			</td>
		)

	}

	renderLoadingComponent(){
		const {loadingComponent} = this.props;

		if(typeof loadingComponent === 'string') {
			return <p className={appendStrings("generic-table-empty-message",this.props.loadingTextClasseName)}>{loadingComponent}</p>
		}
		return loadingComponent;
	}

	renderEmptyMessageComponent(){
		const {emptyMessageComponent} = this.props;
		if(typeof emptyMessageComponent === 'string') {
			return <p className={appendStrings("generic-table-empty-message",this.props.emptyMessageTextClasseName)}>{emptyMessageComponent}</p>
		}
		return emptyMessageComponent;
	}

	renderRows() {
		const {data, loading, loadingComponent, fields, renderActions} = this.props;
		const colSpan = fields.length + (renderActions? 1 : 0);

		if(loading) {
			if(!loadingComponent) return null;
			return(
				<tr className={appendStrings("generic-table-empty-message-container", this.props.loadingRowContainerClasseName)}>
					<td colSpan={colSpan} className={appendStrings("generic-table-empty-message", this.props.loadingContainerClasseName)}>
						{this.renderLoadingComponent()}
					</td>
				</tr>
			)
		}

		if(!data || data.length === 0) {
			return(
				<tr className={appendStrings("generic-table-empty-message-container", this.props.emptyMessageRowContainerClasseName)}>
					<td colSpan={colSpan} className={appendStrings("generic-table-empty-message", this.props.emptyMessageContainerClasseName)}>
						{this.renderEmptyMessageComponent()}
					</td>
				</tr>
			);
		}

		return data.map((row, index) => {
			return (
				<tr className={appendStrings("generic-table-row-container", this.props.dataRowContainerClassName)} key={index} onClick={() => {this.onRowSelected(row, index)}}>
					{this.renderRowsFields(row)}
					{this.renderActions(row, index)}
				</tr>
			)
		})
	}

	renderActionField() {
		const {renderActions, actionsLabel} = this.props;
		if (!renderActions) return null;

		return (
			<th key={"actions"}>{actionsLabel}</th>
		)
	}

	renderFields() {
		const {fields} = this.props;
		if (!fields || fields.length === 0) return null;

		return fields.map((field, index) => {
			const displayName = find(field, 'displayName');
			return(
				<th style={{width: field.width}} className={field.className? field.className : 'generic-table-header-column'} key={field + index}>{displayName || this.capitalize(find(field, 'field'))}</th>
			)
		})
	}

	renderHeader = () => {
		const {headerComponent} = this.props;
		if(headerComponent) {
			return(
				headerComponent
			)
		} else {
			return(
				<tr>
					{this.renderFields()}
					{this.renderActionField()}
				</tr>
			)
		}
	};


	render() {
		return (
			<div>
				<Table striped responsive="sm" style={{overflow: 'auto'}}>
					<thead className='generic-table-header'>
					{this.renderHeader()}
					</thead>
					<tbody>
					{this.renderRows()}
					</tbody>
				</Table>

			</div>
		);
	}
}

GenericTable.defaultProps = {
	fields: null,
	data: null,
	dataContainerClassName: "",
	dataRowContainerClassName: "",
	types: null,
	actionsLabel: 'Actions',
	renderActions: null,
	selectType: 'none',
	headerComponent: null,
	emptyMessageComponent: 'No data found',
	emptyMessageTextClasseName: "",
	emptyMessageContainerClasseName: "",
	emptyMessageRowContainerClasseName: "",
	loading: false,
	loadingComponent: null,
	loadingTextClasseName: "",
	loadingContainerClasseName: "",
	loadingRowContainerClasseName: "",
};

GenericTable.propTypes = {
	fields: PropTypes.arrayOf(
		PropTypes.shape({
			field: PropTypes.string.isRequired,
			displayName: PropTypes.string,
			width: PropTypes.number,
			renderCustomValue: PropTypes.func,
			component: PropTypes.func,
		})
	).isRequired,
	data: PropTypes.array,
	dataContainerClassName: PropTypes.string,
	dataRowContainerClassName: PropTypes.string,
	types: PropTypes.array,
	actionsLabel: PropTypes.string,
	renderActions: PropTypes.func,
	selectType: PropTypes.oneOf([
		'none',
		'single',
		'multi',
	]),
	emptyMessageComponent: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node,
	]),
	emptyMessageTextClasseName: PropTypes.string,
	emptyMessageContainerClasseName: PropTypes.string,
	emptyMessageRowContainerClasseName: PropTypes.string,
	onSelected: PropTypes.func,
	headerComponent: PropTypes.node,
	loading: PropTypes.bool,
	loadingComponent: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node,
	]),
	loadingTextClasseName: PropTypes.string,
	loadingContainerClasseName: PropTypes.string,
	loadingRowContainerClasseName: PropTypes.string,
};

export default GenericTable;
